const typeMap = {
  BEAST: "Beast",
  DEMON: "Demon",
  DRAGON: "Dragon",
  ELEMENTAL: "Elemental",
  MECHANICAL: "Mech",
  MURLOC: "Murloc",
  NAGA: "Naga",
  PIRATE: "Pirate",
  QUILBOAR: "Quilboar",
  UNDEAD: "Undead",
};

const tribes = Object.values(typeMap);

module.exports = { typeMap, tribes };
